export const ENVIRONMENT = import.meta.env.MODE ? import.meta.env.MODE.toUpperCase() : 'DEVELOPMENT';
export const DEVELOPMENT = ENVIRONMENT === 'DEVELOPMENT';

export const API_BASE_URL = DEVELOPMENT
	? 'http://localhost:5001'
	: ENVIRONMENT === 'PRODUCTION'
	? 'https://apiwissen.charta-der-vielfalt.de'
	: ENVIRONMENT === 'STAGING'
	? 'https://frontendstage.charta-der-vielfalt.de'
	: 'wrong';

console.log({
	ENVIRONMENT,
	DEVELOPMENT,
	API_BASE_URL,
});

export const API_BASE_URL_GQL = `${API_BASE_URL}/graphql`;
export const API_BASE_URL_SSO = `${API_BASE_URL}/sso`;

export const UPLOAD_CATEGORY_IMAGE_ENDPOINT = `${API_BASE_URL}/upload-category-image`;

export const COURSE_MATERIAL_CLOUDFRONT_URL = `${API_BASE_URL}/courses`;

export const CONTACT_EMAIL = 'info@charta-der-vielfalt.de';
export const APP_NAME = 'Charta der Vielfalt';

export const PAYPAL_CLIENT_ID = '';
export const PAYPAL_CURRENCY = 'USD';

//Make sure the text for this version is present in TermsOfServiceView.tsx
export const LATEST_TERMS_VERSION = 1; // This must be a integer (1,2,3...)

// export const OIDC_ENDPOINT_URL =
// 	ENVIRONMENT === 'DEVELOPMENT' || ENVIRONMENT === 'STAGING'
// 		? 'https://aai.demo.meinbildungsraum.de/realms/nbp-aai/protocol/openid-connect'
// 		: undefined;
// export const OIDC_LOGOUT_URL =
// 	ENVIRONMENT === 'DEVELOPMENT' || ENVIRONMENT === 'STAGING'
// 		? 'https://aai.demo.meinbildungsraum.de/realms/nbp-aai/protocol/openid-connect/auth?response_type=code'
// 		: undefined;
// export const OIDC_CLIENT_ID =
// 	ENVIRONMENT === 'DEVELOPMENT' || ENVIRONMENT === 'STAGING'
// 		? 'e08bdeca-462c-4294-8914-459d1a6fb9e7'
// 		: undefined;
